"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let WContactModal = class WContactModal extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
    }
    parent;
    onParent(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("parent");
    }
    item;
    onItem(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("item");
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    resource;
    async $$load_resource() {
        return this.item || this.$fn.schemaDefaults('CreateContactPerson');
    }
    editor;
    async $$load_editor() {
        return this.resource.editor();
    }
    createTitle;
    editTitle;
    ux;
    b_7315092382398562_modalBindings;
    dataMembers = ['resource', 'editor', 'createTitle', 'editTitle', 'ux', 'b_7315092382398562_modalBindings'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                resource: null,
                editor: null,
                createTitle: this.$fn.pgettext("Contactes", "Add contact"),
                editTitle: this.$fn.pgettext("Contactes", "Edit contact"),
                ux: null,
                b_7315092382398562_modalBindings: {
                    size: "md",
                },
            },
        };
    }
    get document() {
        if (this.loaded) {
            return {
                title: this.item == null ? this.createTitle : this.editTitle,
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_9064_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async evh_2248226175642056_close(event, scope) {
        return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
    }
    async act_1040167445267876_closeComponent_9070_getActionArgs($event) {
        return {
            result: {
                value: $event.data.response.data,
            },
        };
    }
    async act_1040167445267876_closeComponent_9072_getActionArgs($event) {
        return {
            result: {},
        };
    }
    async act_1040167445267876_rest_9068_getActionArgs($event) {
        return {
            method: "save",
            container: this.parent.contacts,
            resource: this.editor,
        };
    }
    async evh_1040167445267876_submit(event, scope) {
        return await this.actions.evh_1040167445267876_submit.executeFromDOM(this, event, scope);
    }
    async evh_1419464017721962_clickPreventStop(event, scope) {
        return await this.actions.evh_1419464017721962_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_9064 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_9064_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_9063 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_9064,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_9063],
        });
        const act_2248226175642056_closeComponent_9066 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_2248226175642056_close_9065 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_closeComponent_9066,
            event: "close",
            displayName: "closeComponent",
        });
        const evh_2248226175642056_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_close_9065],
        });
        const act_1040167445267876_closeComponent_9070 = new core_1.actions.CloseComponentAction({
            actionArgs: this.act_1040167445267876_closeComponent_9070_getActionArgs,
            events: [],
        });
        const evh_1040167445267876_saved_9069 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_closeComponent_9070,
            event: "saved",
            displayName: "closeComponent",
        });
        const act_1040167445267876_closeComponent_9072 = new core_1.actions.CloseComponentAction({
            actionArgs: this.act_1040167445267876_closeComponent_9072_getActionArgs,
            events: [],
        });
        const evh_1040167445267876_deleted_9071 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_closeComponent_9072,
            event: "deleted",
            displayName: "closeComponent",
        });
        const act_1040167445267876_rest_9068 = new core_1.actions.RestAction({
            actionArgs: this.act_1040167445267876_rest_9068_getActionArgs,
            displayName: "submit",
            events: [evh_1040167445267876_saved_9069, evh_1040167445267876_deleted_9071],
        });
        const evh_1040167445267876_submit_9067 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_rest_9068,
            event: "submit",
            displayName: "submit",
        });
        const evh_1040167445267876_submit = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1040167445267876_submit_9067],
        });
        const act_1419464017721962_closeComponent_9074 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_1419464017721962_clickPreventStop_9073 = new core_1.actions.EventHandlerImpl({
            action: act_1419464017721962_closeComponent_9074,
            event: "click.prevent.stop",
            displayName: "closeComponent",
        });
        const evh_1419464017721962_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1419464017721962_clickPreventStop_9073],
        });
        return {
            act_7315092382398562_closeModal_9064,
            evh_7315092382398562_close_9063,
            evh_7315092382398562_close,
            act_2248226175642056_closeComponent_9066,
            evh_2248226175642056_close_9065,
            evh_2248226175642056_close,
            act_1040167445267876_closeComponent_9070,
            evh_1040167445267876_saved_9069,
            act_1040167445267876_closeComponent_9072,
            evh_1040167445267876_deleted_9071,
            act_1040167445267876_rest_9068,
            evh_1040167445267876_submit_9067,
            evh_1040167445267876_submit,
            act_1419464017721962_closeComponent_9074,
            evh_1419464017721962_clickPreventStop_9073,
            evh_1419464017721962_clickPreventStop,
            submit: act_1040167445267876_rest_9068,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: Object,
    }),
    __metadata("design:type", Object)
], WContactModal.prototype, "parent", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('parent'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], WContactModal.prototype, "onParent", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Object,
    }),
    __metadata("design:type", Object)
], WContactModal.prototype, "item", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('item'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], WContactModal.prototype, "onItem", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "md",
    }),
    __metadata("design:type", String)
], WContactModal.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], WContactModal.prototype, "onSize", null);
WContactModal = __decorate([
    (0, vue_property_decorator_1.Component)()
], WContactModal);
exports.default = WContactModal;
vue_property_decorator_1.Vue.component("WContactModal", WContactModal);
